(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-io-kotlinx-io-bytestring.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-io-kotlinx-io-bytestring.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-io-kotlinx-io-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-io-kotlinx-io-core'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-bytestring'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-io-kotlinx-io-core'. Its dependency 'kotlinx-io-kotlinx-io-bytestring' was not found. Please, check whether 'kotlinx-io-kotlinx-io-bytestring' is loaded prior to 'kotlinx-io-kotlinx-io-core'.");
    }
    globalThis['kotlinx-io-kotlinx-io-core'] = factory(typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined' ? {} : globalThis['kotlinx-io-kotlinx-io-core'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-io-kotlinx-io-bytestring']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_io_bytestring) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var Long = kotlin_kotlin.$_$.kn;
  var compare = kotlin_kotlin.$_$.je;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var subtract = kotlin_kotlin.$_$.af;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var charArrayOf = kotlin_kotlin.$_$.hf;
  var protoOf = kotlin_kotlin.$_$.eh;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var toString = kotlin_kotlin.$_$.hh;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var toShort = kotlin_kotlin.$_$.gh;
  var add = kotlin_kotlin.$_$.fe;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var fromInt = kotlin_kotlin.$_$.pe;
  var convertToInt = kotlin_kotlin.$_$.le;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.v4;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var UnsafeByteStringOperations_instance = kotlin_org_jetbrains_kotlinx_kotlinx_io_bytestring.$_$.a;
  var AutoCloseable = kotlin_kotlin.$_$.wm;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var toByte = kotlin_kotlin.$_$.fh;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.n5;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var multiply = kotlin_kotlin.$_$.ue;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var charArray = kotlin_kotlin.$_$.if;
  var numberToChar = kotlin_kotlin.$_$.ah;
  var concatToString = kotlin_kotlin.$_$.mj;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.f5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var Exception_init_$Init$_0 = kotlin_kotlin.$_$.h5;
  var Exception_init_$Init$_1 = kotlin_kotlin.$_$.j5;
  var Exception = kotlin_kotlin.$_$.gn;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(Source, 'Source', VOID, VOID, [AutoCloseable]);
  function write$default(source, startIndex, endIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? source.length : endIndex;
    var tmp;
    if ($super === VOID) {
      this.ts8(source, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.ts8.call(this, source, startIndex, endIndex);
    }
    return tmp;
  }
  initMetadataForInterface(Sink, 'Sink', VOID, VOID, [AutoCloseable]);
  initMetadataForClass(Buffer, 'Buffer', Buffer, VOID, [Source, Sink]);
  initMetadataForClass(PeekSource, 'PeekSource', VOID, VOID, [AutoCloseable]);
  initMetadataForClass(RealSource, 'RealSource', VOID, VOID, [Source]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(Segment, 'Segment');
  initMetadataForClass(SegmentCopyTracker, 'SegmentCopyTracker');
  initMetadataForObject(AlwaysSharedCopyTracker, 'AlwaysSharedCopyTracker', VOID, SegmentCopyTracker);
  initMetadataForObject(UnsafeBufferOperations, 'UnsafeBufferOperations');
  initMetadataForClass(SegmentReadContextImpl$1);
  initMetadataForClass(SegmentWriteContextImpl$1);
  initMetadataForClass(BufferIterationContextImpl$1);
  initMetadataForClass(IOException, 'IOException', IOException_init_$Create$, Exception);
  initMetadataForClass(EOFException, 'EOFException', EOFException_init_$Create$, IOException);
  initMetadataForObject(SegmentPool, 'SegmentPool');
  //endregion
  function get_HEX_DIGIT_CHARS() {
    _init_properties__Util_kt__g8tcl9();
    return HEX_DIGIT_CHARS;
  }
  var HEX_DIGIT_CHARS;
  function checkBounds(size, startIndex, endIndex) {
    _init_properties__Util_kt__g8tcl9();
    if (compare(startIndex, new Long(0, 0)) < 0 || compare(endIndex, size) > 0) {
      throw IndexOutOfBoundsException_init_$Create$('startIndex (' + startIndex.toString() + ') and endIndex (' + endIndex.toString() + ') are not within the range [0..size(' + size.toString() + '))');
    }
    if (compare(startIndex, endIndex) > 0) {
      throw IllegalArgumentException_init_$Create$('startIndex (' + startIndex.toString() + ') > endIndex (' + endIndex.toString() + ')');
    }
  }
  function checkOffsetAndCount(size, offset, byteCount) {
    _init_properties__Util_kt__g8tcl9();
    if (compare(offset, new Long(0, 0)) < 0 || compare(offset, size) > 0 || compare(subtract(size, offset), byteCount) < 0 || compare(byteCount, new Long(0, 0)) < 0) {
      throw IllegalArgumentException_init_$Create$('offset (' + offset.toString() + ') and byteCount (' + byteCount.toString() + ') are not within the range [0..size(' + size.toString() + '))');
    }
  }
  var properties_initialized__Util_kt_67kc5b;
  function _init_properties__Util_kt__g8tcl9() {
    if (!properties_initialized__Util_kt_67kc5b) {
      properties_initialized__Util_kt_67kc5b = true;
      // Inline function 'kotlin.charArrayOf' call
      HEX_DIGIT_CHARS = charArrayOf([_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(49), _Char___init__impl__6a9atx(50), _Char___init__impl__6a9atx(51), _Char___init__impl__6a9atx(52), _Char___init__impl__6a9atx(53), _Char___init__impl__6a9atx(54), _Char___init__impl__6a9atx(55), _Char___init__impl__6a9atx(56), _Char___init__impl__6a9atx(57), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(99), _Char___init__impl__6a9atx(100), _Char___init__impl__6a9atx(101), _Char___init__impl__6a9atx(102)]);
    }
  }
  function throwEof($this, byteCount) {
    throw EOFException_init_$Create$_0("Buffer doesn't contain required number of bytes (size: " + $this.n1().toString() + ', required: ' + byteCount.toString() + ')');
  }
  function Buffer() {
    this.is7_1 = null;
    this.js7_1 = null;
    this.ks7_1 = new Long(0, 0);
  }
  protoOf(Buffer).n1 = function () {
    return this.ks7_1;
  };
  protoOf(Buffer).ls7 = function () {
    return this;
  };
  protoOf(Buffer).ms7 = function () {
    return equalsLong(this.n1(), new Long(0, 0));
  };
  protoOf(Buffer).ns7 = function (byteCount) {
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
      var message = 'byteCount: ' + byteCount.toString();
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (compare(this.n1(), byteCount) < 0) {
      throw EOFException_init_$Create$_0("Buffer doesn't contain required number of bytes (size: " + this.n1().toString() + ', required: ' + byteCount.toString() + ')');
    }
  };
  protoOf(Buffer).os7 = function (byteCount) {
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
      var message = 'byteCount: ' + byteCount.toString() + ' < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return compare(this.n1(), byteCount) >= 0;
  };
  protoOf(Buffer).ps7 = function () {
    var tmp0_elvis_lhs = this.is7_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwEof(this, new Long(1, 0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var segment = tmp;
    var segmentSize = segment.n1();
    if (segmentSize === 0) {
      this.xs7();
      return this.ps7();
    }
    var v = segment.ys7();
    this.ks7_1 = subtract(this.ks7_1, new Long(1, 0));
    if (segmentSize === 1) {
      this.xs7();
    }
    return v;
  };
  protoOf(Buffer).zs7 = function () {
    var tmp0_elvis_lhs = this.is7_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwEof(this, new Long(2, 0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var segment = tmp;
    var segmentSize = segment.n1();
    if (segmentSize < 2) {
      this.ns7(new Long(2, 0));
      if (segmentSize === 0) {
        this.xs7();
        return this.zs7();
      }
      // Inline function 'kotlinx.io.and' call
      var tmp_0 = (this.ps7() & 255) << 8;
      // Inline function 'kotlinx.io.and' call
      var tmp$ret$1 = this.ps7() & 255;
      return toShort(tmp_0 | tmp$ret$1);
    }
    var v = segment.as8();
    this.ks7_1 = subtract(this.ks7_1, new Long(2, 0));
    if (segmentSize === 2) {
      this.xs7();
    }
    return v;
  };
  protoOf(Buffer).bs8 = function () {
    return Unit_instance;
  };
  protoOf(Buffer).cs8 = function (out, startIndex, endIndex) {
    checkBounds(this.n1(), startIndex, endIndex);
    if (equalsLong(startIndex, endIndex))
      return Unit_instance;
    var currentOffset = startIndex;
    var remainingByteCount = subtract(endIndex, startIndex);
    out.ks7_1 = add(out.ks7_1, remainingByteCount);
    var s = this.is7_1;
    while (compare(currentOffset, fromInt(ensureNotNull(s).ss7_1 - s.rs7_1 | 0)) >= 0) {
      currentOffset = subtract(currentOffset, fromInt(s.ss7_1 - s.rs7_1 | 0));
      s = s.vs7_1;
    }
    while (compare(remainingByteCount, new Long(0, 0)) > 0) {
      var copy = ensureNotNull(s).ds8();
      copy.rs7_1 = copy.rs7_1 + convertToInt(currentOffset) | 0;
      var tmp = copy;
      var tmp0 = copy.rs7_1 + convertToInt(remainingByteCount) | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = copy.ss7_1;
      tmp.ss7_1 = Math.min(tmp0, b);
      // Inline function 'kotlinx.io.Buffer.pushSegment' call
      if (out.is7_1 == null) {
        out.is7_1 = copy;
        out.js7_1 = copy;
      } else if (false) {
        out.js7_1 = ensureNotNull(out.js7_1).es8(copy).fs8();
        if (ensureNotNull(out.js7_1).ws7_1 == null) {
          out.is7_1 = out.js7_1;
        }
      } else {
        out.js7_1 = ensureNotNull(out.js7_1).es8(copy);
      }
      remainingByteCount = subtract(remainingByteCount, fromInt(copy.ss7_1 - copy.rs7_1 | 0));
      currentOffset = new Long(0, 0);
      s = s.vs7_1;
    }
  };
  protoOf(Buffer).gs8 = function () {
    var result = this.n1();
    if (equalsLong(result, new Long(0, 0)))
      return new Long(0, 0);
    var tail = ensureNotNull(this.js7_1);
    if (tail.ss7_1 < 8192 && tail.us7_1) {
      result = subtract(result, fromInt(tail.ss7_1 - tail.rs7_1 | 0));
    }
    return result;
  };
  protoOf(Buffer).lx = function (position) {
    if (compare(position, new Long(0, 0)) < 0 || compare(position, this.n1()) >= 0) {
      throw IndexOutOfBoundsException_init_$Create$('position (' + position.toString() + ') is not within the range [0..size(' + this.n1().toString() + '))');
    }
    if (equalsLong(position, new Long(0, 0))) {
      return ensureNotNull(this.is7_1).hs8(0);
    }
    $l$block_1: {
      // Inline function 'kotlinx.io.seek' call
      if (this.is7_1 == null) {
        var offset = new Long(-1, -1);
        return ensureNotNull(null).hs8(convertToInt(subtract(position, offset)));
      }
      if (compare(subtract(this.n1(), position), position) < 0) {
        var s = this.js7_1;
        var offset_0 = this.n1();
        $l$loop: while (!(s == null) && compare(offset_0, position) > 0) {
          offset_0 = subtract(offset_0, fromInt(s.ss7_1 - s.rs7_1 | 0));
          if (compare(offset_0, position) <= 0)
            break $l$loop;
          s = s.ws7_1;
        }
        var tmp0 = s;
        var offset_1 = offset_0;
        return ensureNotNull(tmp0).hs8(convertToInt(subtract(position, offset_1)));
      } else {
        var s_0 = this.is7_1;
        var offset_2 = new Long(0, 0);
        $l$loop_0: while (!(s_0 == null)) {
          var tmp0_0 = offset_2;
          // Inline function 'kotlin.Long.plus' call
          var other = s_0.ss7_1 - s_0.rs7_1 | 0;
          var nextOffset = add(tmp0_0, fromInt(other));
          if (compare(nextOffset, position) > 0)
            break $l$loop_0;
          s_0 = s_0.vs7_1;
          offset_2 = nextOffset;
        }
        var tmp0_1 = s_0;
        var offset_3 = offset_2;
        return ensureNotNull(tmp0_1).hs8(convertToInt(subtract(position, offset_3)));
      }
    }
  };
  protoOf(Buffer).c3 = function () {
    return this.is8(this.n1());
  };
  protoOf(Buffer).is8 = function (byteCount) {
    // Inline function 'kotlinx.io.checkByteCount' call
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
      var message = 'byteCount (' + byteCount.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var remainingByteCount = byteCount;
    while (compare(remainingByteCount, new Long(0, 0)) > 0) {
      var tmp0_elvis_lhs = this.is7_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        throw EOFException_init_$Create$_0('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var head = tmp;
      var tmp0 = remainingByteCount;
      // Inline function 'kotlinx.io.minOf' call
      var b = head.ss7_1 - head.rs7_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b_0 = fromInt(b);
      var tmp$ret$3 = compare(tmp0, b_0) <= 0 ? tmp0 : b_0;
      var toSkip = convertToInt(tmp$ret$3);
      this.ks7_1 = subtract(this.ks7_1, fromInt(toSkip));
      remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
      head.rs7_1 = head.rs7_1 + toSkip | 0;
      if (head.rs7_1 === head.ss7_1) {
        this.xs7();
      }
    }
  };
  protoOf(Buffer).js8 = function (sink, startIndex, endIndex) {
    // Inline function 'kotlinx.io.checkBounds' call
    var size = sink.length;
    checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
    var tmp0_elvis_lhs = this.is7_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return -1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var s = tmp;
    var tmp0 = endIndex - startIndex | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = s.n1();
    var toCopy = Math.min(tmp0, b);
    s.ks8(sink, startIndex, startIndex + toCopy | 0);
    this.ks7_1 = subtract(this.ks7_1, fromInt(toCopy));
    if (isEmpty(s)) {
      this.xs7();
    }
    return toCopy;
  };
  protoOf(Buffer).ls8 = function (sink, byteCount) {
    // Inline function 'kotlinx.io.checkByteCount' call
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
      var message = 'byteCount (' + byteCount.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (equalsLong(this.n1(), new Long(0, 0)))
      return new Long(-1, -1);
    var bytesWritten = compare(byteCount, this.n1()) > 0 ? this.n1() : byteCount;
    sink.ms8(this, bytesWritten);
    return bytesWritten;
  };
  protoOf(Buffer).ns8 = function (sink, byteCount) {
    // Inline function 'kotlinx.io.checkByteCount' call
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
      var message = 'byteCount (' + byteCount.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (compare(this.n1(), byteCount) < 0) {
      sink.ms8(this, this.n1());
      throw EOFException_init_$Create$_0('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.n1().toString() + ' bytes were written.');
    }
    sink.ms8(this, byteCount);
  };
  protoOf(Buffer).os8 = function (sink) {
    var byteCount = this.n1();
    if (compare(byteCount, new Long(0, 0)) > 0) {
      sink.ms8(this, byteCount);
    }
    return byteCount;
  };
  protoOf(Buffer).v3n = function () {
    return buffered(new PeekSource(this));
  };
  protoOf(Buffer).ps8 = function (minimumCapacity) {
    // Inline function 'kotlin.require' call
    if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
      var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (this.js7_1 == null) {
      var result = SegmentPool_instance.ss8();
      this.is7_1 = result;
      this.js7_1 = result;
      return result;
    }
    var t = ensureNotNull(this.js7_1);
    if ((t.ss7_1 + minimumCapacity | 0) > 8192 || !t.us7_1) {
      var newTail = t.es8(SegmentPool_instance.ss8());
      this.js7_1 = newTail;
      return newTail;
    }
    return t;
  };
  protoOf(Buffer).ts8 = function (source, startIndex, endIndex) {
    // Inline function 'kotlinx.io.checkBounds' call
    var size = source.length;
    checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
    var currentOffset = startIndex;
    while (currentOffset < endIndex) {
      var tail = this.ps8(1);
      var tmp0 = endIndex - currentOffset | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = tail.us8();
      var toCopy = Math.min(tmp0, b);
      tail.vs8(source, currentOffset, currentOffset + toCopy | 0);
      currentOffset = currentOffset + toCopy | 0;
    }
    var tmp = this;
    var tmp0_0 = this.ks7_1;
    // Inline function 'kotlin.Long.plus' call
    var other = endIndex - startIndex | 0;
    tmp.ks7_1 = add(tmp0_0, fromInt(other));
  };
  protoOf(Buffer).ms8 = function (source, byteCount) {
    // Inline function 'kotlin.require' call
    if (!!(source === this)) {
      var message = 'source == this';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    checkOffsetAndCount(source.ks7_1, new Long(0, 0), byteCount);
    var remainingByteCount = byteCount;
    while (compare(remainingByteCount, new Long(0, 0)) > 0) {
      if (compare(remainingByteCount, fromInt(ensureNotNull(source.is7_1).n1())) < 0) {
        var tail = this.js7_1;
        var tmp;
        if (!(tail == null) && tail.us7_1) {
          var tmp0 = remainingByteCount;
          // Inline function 'kotlin.Long.plus' call
          var other = tail.ss7_1;
          var tmp0_0 = add(tmp0, fromInt(other));
          // Inline function 'kotlin.Long.minus' call
          var other_0 = tail.xs8() ? 0 : tail.rs7_1;
          var tmp$ret$3 = subtract(tmp0_0, fromInt(other_0));
          tmp = compare(tmp$ret$3, new Long(8192, 0)) <= 0;
        } else {
          tmp = false;
        }
        if (tmp) {
          ensureNotNull(source.is7_1).zs8(tail, convertToInt(remainingByteCount));
          source.ks7_1 = subtract(source.ks7_1, remainingByteCount);
          this.ks7_1 = add(this.ks7_1, remainingByteCount);
          return Unit_instance;
        } else {
          source.is7_1 = ensureNotNull(source.is7_1).ys8(convertToInt(remainingByteCount));
        }
      }
      var segmentToMove = ensureNotNull(source.is7_1);
      var movedByteCount = fromInt(segmentToMove.n1());
      source.is7_1 = segmentToMove.as9();
      if (source.is7_1 == null) {
        source.js7_1 = null;
      }
      // Inline function 'kotlinx.io.Buffer.pushSegment' call
      if (this.is7_1 == null) {
        this.is7_1 = segmentToMove;
        this.js7_1 = segmentToMove;
      } else if (true) {
        this.js7_1 = ensureNotNull(this.js7_1).es8(segmentToMove).fs8();
        if (ensureNotNull(this.js7_1).ws7_1 == null) {
          this.is7_1 = this.js7_1;
        }
      } else {
        this.js7_1 = ensureNotNull(this.js7_1).es8(segmentToMove);
      }
      source.ks7_1 = subtract(source.ks7_1, movedByteCount);
      this.ks7_1 = add(this.ks7_1, movedByteCount);
      remainingByteCount = subtract(remainingByteCount, movedByteCount);
    }
  };
  protoOf(Buffer).bs9 = function (source) {
    var totalBytesRead = new Long(0, 0);
    $l$loop: while (true) {
      var readCount = source.ls8(this, new Long(8192, 0));
      if (equalsLong(readCount, new Long(-1, -1)))
        break $l$loop;
      totalBytesRead = add(totalBytesRead, readCount);
    }
    return totalBytesRead;
  };
  protoOf(Buffer).cs9 = function (byte) {
    this.ps8(1).ds9(byte);
    this.ks7_1 = add(this.ks7_1, new Long(1, 0));
  };
  protoOf(Buffer).es9 = function (short) {
    this.ps8(2).fs9(short);
    this.ks7_1 = add(this.ks7_1, new Long(2, 0));
  };
  protoOf(Buffer).j4 = function () {
    return Unit_instance;
  };
  protoOf(Buffer).toString = function () {
    if (equalsLong(this.n1(), new Long(0, 0)))
      return 'Buffer(size=0)';
    var maxPrintableBytes = 64;
    // Inline function 'kotlinx.io.minOf' call
    var b = this.n1();
    // Inline function 'kotlin.comparisons.minOf' call
    var a = fromInt(maxPrintableBytes);
    var tmp$ret$0 = compare(a, b) <= 0 ? a : b;
    var len = convertToInt(tmp$ret$0);
    var builder = StringBuilder_init_$Create$(imul(len, 2) + (compare(this.n1(), fromInt(maxPrintableBytes)) > 0 ? 1 : 0) | 0);
    var bytesWritten = 0;
    // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
    var curr = this.is7_1;
    while (!(curr == null)) {
      var tmp0 = get_SegmentReadContextImpl();
      var segment = curr;
      var idx = 0;
      while (bytesWritten < len && idx < segment.n1()) {
        var _unary__edvuaz = idx;
        idx = _unary__edvuaz + 1 | 0;
        var b_0 = tmp0.gs9(segment, _unary__edvuaz);
        bytesWritten = bytesWritten + 1 | 0;
        var tmp = get_HEX_DIGIT_CHARS();
        // Inline function 'kotlinx.io.shr' call
        var tmp$ret$4 = b_0 >> 4;
        var tmp_0 = builder.s(tmp[tmp$ret$4 & 15]);
        var tmp_1 = get_HEX_DIGIT_CHARS();
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$5 = b_0 & 15;
        tmp_0.s(tmp_1[tmp$ret$5]);
      }
      curr = curr.vs7_1;
    }
    if (compare(this.n1(), fromInt(maxPrintableBytes)) > 0) {
      builder.s(_Char___init__impl__6a9atx(8230));
    }
    return 'Buffer(size=' + this.n1().toString() + ' hex=' + builder.toString() + ')';
  };
  protoOf(Buffer).xs7 = function () {
    var oldHead = ensureNotNull(this.is7_1);
    var nextHead = oldHead.vs7_1;
    this.is7_1 = nextHead;
    if (nextHead == null) {
      this.js7_1 = null;
    } else {
      nextHead.ws7_1 = null;
    }
    oldHead.vs7_1 = null;
    SegmentPool_instance.hs9(oldHead);
  };
  protoOf(Buffer).is9 = function () {
    var oldTail = ensureNotNull(this.js7_1);
    var newTail = oldTail.ws7_1;
    this.js7_1 = newTail;
    if (newTail == null) {
      this.is7_1 = null;
    } else {
      newTail.vs7_1 = null;
    }
    oldTail.ws7_1 = null;
    SegmentPool_instance.hs9(oldTail);
  };
  function indexOf(_this__u8e3s4, byte, startIndex, endIndex) {
    startIndex = startIndex === VOID ? new Long(0, 0) : startIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.n1() : endIndex;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = _this__u8e3s4.n1();
    var endOffset = compare(endIndex, b) <= 0 ? endIndex : b;
    checkBounds(_this__u8e3s4.n1(), startIndex, endOffset);
    if (equalsLong(startIndex, endOffset))
      return new Long(-1, -1);
    $l$block_1: {
      // Inline function 'kotlinx.io.seek' call
      if (_this__u8e3s4.is7_1 == null) {
        var o = new Long(-1, -1);
        if (equalsLong(o, new Long(-1, -1))) {
          return new Long(-1, -1);
        }
        var segment = null;
        var offset = o;
        do {
          // Inline function 'kotlin.check' call
          if (!(compare(endOffset, offset) > 0)) {
            throw IllegalStateException_init_$Create$('Check failed.');
          }
          ensureNotNull(segment);
          var tmp = segment;
          // Inline function 'kotlin.comparisons.maxOf' call
          var a = convertToInt(subtract(startIndex, offset));
          var tmp_0 = Math.max(a, 0);
          var tmp0 = segment.n1();
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = convertToInt(subtract(endOffset, offset));
          var tmp$ret$5 = Math.min(tmp0, b_0);
          var idx = indexOf_0(tmp, byte, tmp_0, tmp$ret$5);
          if (!(idx === -1)) {
            return add(offset, fromInt(idx));
          }
          var tmp0_0 = offset;
          // Inline function 'kotlin.Long.plus' call
          var other = segment.n1();
          offset = add(tmp0_0, fromInt(other));
          segment = segment.vs7_1;
        }
         while (!(segment == null) && compare(offset, endOffset) < 0);
        return new Long(-1, -1);
      }
      if (compare(subtract(_this__u8e3s4.n1(), startIndex), startIndex) < 0) {
        var s = _this__u8e3s4.js7_1;
        var offset_0 = _this__u8e3s4.n1();
        $l$loop: while (!(s == null) && compare(offset_0, startIndex) > 0) {
          offset_0 = subtract(offset_0, fromInt(s.ss7_1 - s.rs7_1 | 0));
          if (compare(offset_0, startIndex) <= 0)
            break $l$loop;
          s = s.ws7_1;
        }
        var tmp0_1 = s;
        var o_0 = offset_0;
        if (equalsLong(o_0, new Long(-1, -1))) {
          return new Long(-1, -1);
        }
        var segment_0 = tmp0_1;
        var offset_1 = o_0;
        do {
          // Inline function 'kotlin.check' call
          if (!(compare(endOffset, offset_1) > 0)) {
            throw IllegalStateException_init_$Create$('Check failed.');
          }
          ensureNotNull(segment_0);
          var tmp_1 = segment_0;
          // Inline function 'kotlin.comparisons.maxOf' call
          var a_0 = convertToInt(subtract(startIndex, offset_1));
          var tmp_2 = Math.max(a_0, 0);
          var tmp0_2 = segment_0.n1();
          // Inline function 'kotlin.comparisons.minOf' call
          var b_1 = convertToInt(subtract(endOffset, offset_1));
          var tmp$ret$10 = Math.min(tmp0_2, b_1);
          var idx_0 = indexOf_0(tmp_1, byte, tmp_2, tmp$ret$10);
          if (!(idx_0 === -1)) {
            return add(offset_1, fromInt(idx_0));
          }
          var tmp0_3 = offset_1;
          // Inline function 'kotlin.Long.plus' call
          var other_0 = segment_0.n1();
          offset_1 = add(tmp0_3, fromInt(other_0));
          segment_0 = segment_0.vs7_1;
        }
         while (!(segment_0 == null) && compare(offset_1, endOffset) < 0);
        return new Long(-1, -1);
      } else {
        var s_0 = _this__u8e3s4.is7_1;
        var offset_2 = new Long(0, 0);
        $l$loop_0: while (!(s_0 == null)) {
          var tmp0_4 = offset_2;
          // Inline function 'kotlin.Long.plus' call
          var other_1 = s_0.ss7_1 - s_0.rs7_1 | 0;
          var nextOffset = add(tmp0_4, fromInt(other_1));
          if (compare(nextOffset, startIndex) > 0)
            break $l$loop_0;
          s_0 = s_0.vs7_1;
          offset_2 = nextOffset;
        }
        var tmp0_5 = s_0;
        var o_1 = offset_2;
        if (equalsLong(o_1, new Long(-1, -1))) {
          return new Long(-1, -1);
        }
        var segment_1 = tmp0_5;
        var offset_3 = o_1;
        do {
          // Inline function 'kotlin.check' call
          if (!(compare(endOffset, offset_3) > 0)) {
            throw IllegalStateException_init_$Create$('Check failed.');
          }
          ensureNotNull(segment_1);
          var tmp_3 = segment_1;
          // Inline function 'kotlin.comparisons.maxOf' call
          var a_1 = convertToInt(subtract(startIndex, offset_3));
          var tmp_4 = Math.max(a_1, 0);
          var tmp0_6 = segment_1.n1();
          // Inline function 'kotlin.comparisons.minOf' call
          var b_2 = convertToInt(subtract(endOffset, offset_3));
          var tmp$ret$16 = Math.min(tmp0_6, b_2);
          var idx_1 = indexOf_0(tmp_3, byte, tmp_4, tmp$ret$16);
          if (!(idx_1 === -1)) {
            return add(offset_3, fromInt(idx_1));
          }
          var tmp0_7 = offset_3;
          // Inline function 'kotlin.Long.plus' call
          var other_2 = segment_1.n1();
          offset_3 = add(tmp0_7, fromInt(other_2));
          segment_1 = segment_1.vs7_1;
        }
         while (!(segment_1 == null) && compare(offset_3, endOffset) < 0);
        return new Long(-1, -1);
      }
    }
  }
  function readByteString(_this__u8e3s4, byteCount) {
    return UnsafeByteStringOperations_instance.hs7(readByteArray_0(_this__u8e3s4, byteCount));
  }
  function buffered(_this__u8e3s4) {
    return new RealSource(_this__u8e3s4);
  }
  function PeekSource(upstream) {
    this.js9_1 = upstream;
    this.ks9_1 = this.js9_1.ls7();
    this.ls9_1 = this.ks9_1.is7_1;
    var tmp = this;
    var tmp0_safe_receiver = this.ks9_1.is7_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rs7_1;
    tmp.ms9_1 = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
    this.ns9_1 = false;
    this.os9_1 = new Long(0, 0);
  }
  protoOf(PeekSource).ls8 = function (sink, byteCount) {
    // Inline function 'kotlin.check' call
    if (!!this.ns9_1) {
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlinx.io.checkByteCount' call
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
      var message_0 = 'byteCount (' + byteCount.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!(this.ls9_1 == null || (this.ls9_1 === this.ks9_1.is7_1 && this.ms9_1 === ensureNotNull(this.ks9_1.is7_1).rs7_1))) {
      var message_1 = 'Peek source is invalid because upstream source was used';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
    if (equalsLong(byteCount, new Long(0, 0)))
      return new Long(0, 0);
    // Inline function 'kotlin.Long.plus' call
    var this_0 = this.os9_1;
    var tmp$ret$7 = add(this_0, fromInt(1));
    if (!this.js9_1.os7(tmp$ret$7))
      return new Long(-1, -1);
    if (this.ls9_1 == null && !(this.ks9_1.is7_1 == null)) {
      this.ls9_1 = this.ks9_1.is7_1;
      this.ms9_1 = ensureNotNull(this.ks9_1.is7_1).rs7_1;
    }
    // Inline function 'kotlin.comparisons.minOf' call
    var b = subtract(this.ks9_1.n1(), this.os9_1);
    var toCopy = compare(byteCount, b) <= 0 ? byteCount : b;
    this.ks9_1.cs8(sink, this.os9_1, add(this.os9_1, toCopy));
    this.os9_1 = add(this.os9_1, toCopy);
    return toCopy;
  };
  protoOf(PeekSource).j4 = function () {
    this.ns9_1 = true;
  };
  function RealSource(source) {
    this.ps9_1 = source;
    this.qs9_1 = false;
    this.rs9_1 = new Buffer();
  }
  protoOf(RealSource).ls7 = function () {
    return this.rs9_1;
  };
  protoOf(RealSource).ls8 = function (sink, byteCount) {
    // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
    // Inline function 'kotlin.check' call
    if (!!this.qs9_1) {
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
      var message_0 = 'byteCount: ' + byteCount.toString();
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    if (equalsLong(this.rs9_1.n1(), new Long(0, 0))) {
      var read = this.ps9_1.ls8(this.rs9_1, new Long(8192, 0));
      if (equalsLong(read, new Long(-1, -1)))
        return new Long(-1, -1);
    }
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.rs9_1.n1();
    var toRead = compare(byteCount, b) <= 0 ? byteCount : b;
    return this.rs9_1.ls8(sink, toRead);
  };
  protoOf(RealSource).ms7 = function () {
    // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
    // Inline function 'kotlin.check' call
    if (!!this.qs9_1) {
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return this.rs9_1.ms7() && equalsLong(this.ps9_1.ls8(this.rs9_1, new Long(8192, 0)), new Long(-1, -1));
  };
  protoOf(RealSource).ns7 = function (byteCount) {
    if (!this.os7(byteCount))
      throw EOFException_init_$Create$_0("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
  };
  protoOf(RealSource).os7 = function (byteCount) {
    // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
    // Inline function 'kotlin.check' call
    if (!!this.qs9_1) {
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount, new Long(0, 0)) >= 0)) {
      var message_0 = 'byteCount: ' + byteCount.toString();
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    while (compare(this.rs9_1.n1(), byteCount) < 0) {
      if (equalsLong(this.ps9_1.ls8(this.rs9_1, new Long(8192, 0)), new Long(-1, -1)))
        return false;
    }
    return true;
  };
  protoOf(RealSource).ps7 = function () {
    this.ns7(new Long(1, 0));
    return this.rs9_1.ps7();
  };
  protoOf(RealSource).js8 = function (sink, startIndex, endIndex) {
    // Inline function 'kotlinx.io.checkBounds' call
    var size = sink.length;
    checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
    if (equalsLong(this.rs9_1.n1(), new Long(0, 0))) {
      var read = this.ps9_1.ls8(this.rs9_1, new Long(8192, 0));
      if (equalsLong(read, new Long(-1, -1)))
        return -1;
    }
    var tmp0 = endIndex - startIndex | 0;
    // Inline function 'kotlinx.io.minOf' call
    var b = this.rs9_1.n1();
    // Inline function 'kotlin.comparisons.minOf' call
    var a = fromInt(tmp0);
    var tmp$ret$1 = compare(a, b) <= 0 ? a : b;
    var toRead = convertToInt(tmp$ret$1);
    return this.rs9_1.js8(sink, startIndex, startIndex + toRead | 0);
  };
  protoOf(RealSource).ns8 = function (sink, byteCount) {
    try {
      this.ns7(byteCount);
    } catch ($p) {
      if ($p instanceof EOFException) {
        var e = $p;
        sink.ms8(this.rs9_1, this.rs9_1.n1());
        throw e;
      } else {
        throw $p;
      }
    }
    this.rs9_1.ns8(sink, byteCount);
  };
  protoOf(RealSource).os8 = function (sink) {
    var totalBytesWritten = new Long(0, 0);
    while (!equalsLong(this.ps9_1.ls8(this.rs9_1, new Long(8192, 0)), new Long(-1, -1))) {
      var emitByteCount = this.rs9_1.gs8();
      if (compare(emitByteCount, new Long(0, 0)) > 0) {
        totalBytesWritten = add(totalBytesWritten, emitByteCount);
        sink.ms8(this.rs9_1, emitByteCount);
      }
    }
    if (compare(this.rs9_1.n1(), new Long(0, 0)) > 0) {
      totalBytesWritten = add(totalBytesWritten, this.rs9_1.n1());
      sink.ms8(this.rs9_1, this.rs9_1.n1());
    }
    return totalBytesWritten;
  };
  protoOf(RealSource).zs7 = function () {
    this.ns7(new Long(2, 0));
    return this.rs9_1.zs7();
  };
  protoOf(RealSource).v3n = function () {
    // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
    // Inline function 'kotlin.check' call
    if (!!this.qs9_1) {
      var message = 'Source is closed.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return buffered(new PeekSource(this));
  };
  protoOf(RealSource).j4 = function () {
    if (this.qs9_1)
      return Unit_instance;
    this.qs9_1 = true;
    this.ps9_1.j4();
    this.rs9_1.c3();
  };
  protoOf(RealSource).toString = function () {
    return 'buffered(' + toString(this.ps9_1) + ')';
  };
  function Segment_init_$Init$($this) {
    Segment.call($this);
    $this.qs7_1 = new Int8Array(8192);
    $this.us7_1 = true;
    $this.ts7_1 = null;
    return $this;
  }
  function Segment_init_$Create$() {
    return Segment_init_$Init$(objectCreate(protoOf(Segment)));
  }
  function Segment_init_$Init$_0(data, pos, limit, shareToken, owner, $this) {
    Segment.call($this);
    $this.qs7_1 = data;
    $this.rs7_1 = pos;
    $this.ss7_1 = limit;
    $this.ts7_1 = shareToken;
    $this.us7_1 = owner;
    return $this;
  }
  function Segment_init_$Create$_0(data, pos, limit, shareToken, owner) {
    return Segment_init_$Init$_0(data, pos, limit, shareToken, owner, objectCreate(protoOf(Segment)));
  }
  function Companion() {
    this.ss9_1 = 8192;
    this.ts9_1 = 1024;
  }
  protoOf(Companion).us9 = function () {
    return Segment_init_$Create$();
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  protoOf(Segment).xs8 = function () {
    var tmp0_safe_receiver = this.ts7_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vs9();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(Segment).ds8 = function () {
    var tmp0_elvis_lhs = this.ts7_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = SegmentPool_instance.ws9();
      this.ts7_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var t = tmp;
    var tmp_0 = this.rs7_1;
    var tmp_1 = this.ss7_1;
    // Inline function 'kotlin.also' call
    t.xs9();
    return Segment_init_$Create$_0(this.qs7_1, tmp_0, tmp_1, t, false);
  };
  protoOf(Segment).as9 = function () {
    var result = this.vs7_1;
    if (!(this.ws7_1 == null)) {
      ensureNotNull(this.ws7_1).vs7_1 = this.vs7_1;
    }
    if (!(this.vs7_1 == null)) {
      ensureNotNull(this.vs7_1).ws7_1 = this.ws7_1;
    }
    this.vs7_1 = null;
    this.ws7_1 = null;
    return result;
  };
  protoOf(Segment).es8 = function (segment) {
    segment.ws7_1 = this;
    segment.vs7_1 = this.vs7_1;
    if (!(this.vs7_1 == null)) {
      ensureNotNull(this.vs7_1).ws7_1 = segment;
    }
    this.vs7_1 = segment;
    return segment;
  };
  protoOf(Segment).ys8 = function (byteCount) {
    // Inline function 'kotlin.require' call
    if (!(byteCount > 0 && byteCount <= (this.ss7_1 - this.rs7_1 | 0))) {
      var message = 'byteCount out of range';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var prefix;
    if (byteCount >= 1024) {
      prefix = this.ds8();
    } else {
      prefix = SegmentPool_instance.ss8();
      var tmp0 = this.qs7_1;
      var tmp2 = prefix.qs7_1;
      var tmp5 = this.rs7_1;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = this.rs7_1 + byteCount | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
    }
    prefix.ss7_1 = prefix.rs7_1 + byteCount | 0;
    this.rs7_1 = this.rs7_1 + byteCount | 0;
    if (!(this.ws7_1 == null)) {
      ensureNotNull(this.ws7_1).es8(prefix);
    } else {
      prefix.vs7_1 = this;
      this.ws7_1 = prefix;
    }
    return prefix;
  };
  protoOf(Segment).fs8 = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.ws7_1 == null)) {
      var message = 'cannot compact';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (!ensureNotNull(this.ws7_1).us7_1)
      return this;
    var byteCount = this.ss7_1 - this.rs7_1 | 0;
    var availableByteCount = (8192 - ensureNotNull(this.ws7_1).ss7_1 | 0) + (ensureNotNull(this.ws7_1).xs8() ? 0 : ensureNotNull(this.ws7_1).rs7_1) | 0;
    if (byteCount > availableByteCount)
      return this;
    var predecessor = this.ws7_1;
    this.zs8(ensureNotNull(predecessor), byteCount);
    var successor = this.as9();
    // Inline function 'kotlin.check' call
    if (!(successor == null)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    SegmentPool_instance.hs9(this);
    return predecessor;
  };
  protoOf(Segment).ds9 = function (byte) {
    var _unary__edvuaz = this.ss7_1;
    this.ss7_1 = _unary__edvuaz + 1 | 0;
    this.qs7_1[_unary__edvuaz] = byte;
  };
  protoOf(Segment).fs9 = function (short) {
    var data = this.qs7_1;
    var limit = this.ss7_1;
    var _unary__edvuaz = limit;
    limit = _unary__edvuaz + 1 | 0;
    data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
    var _unary__edvuaz_0 = limit;
    limit = _unary__edvuaz_0 + 1 | 0;
    data[_unary__edvuaz_0] = toByte(short & 255);
    this.ss7_1 = limit;
  };
  protoOf(Segment).ys7 = function () {
    var _unary__edvuaz = this.rs7_1;
    this.rs7_1 = _unary__edvuaz + 1 | 0;
    return this.qs7_1[_unary__edvuaz];
  };
  protoOf(Segment).as8 = function () {
    var data = this.qs7_1;
    var pos = this.rs7_1;
    var _unary__edvuaz = pos;
    pos = _unary__edvuaz + 1 | 0;
    // Inline function 'kotlinx.io.and' call
    var tmp = (data[_unary__edvuaz] & 255) << 8;
    var _unary__edvuaz_0 = pos;
    pos = _unary__edvuaz_0 + 1 | 0;
    // Inline function 'kotlinx.io.and' call
    var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
    var s = toShort(tmp | tmp$ret$1);
    this.rs7_1 = pos;
    return s;
  };
  protoOf(Segment).zs8 = function (sink, byteCount) {
    // Inline function 'kotlin.check' call
    if (!sink.us7_1) {
      var message = 'only owner can write';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if ((sink.ss7_1 + byteCount | 0) > 8192) {
      if (sink.xs8())
        throw IllegalArgumentException_init_$Create$_0();
      if (((sink.ss7_1 + byteCount | 0) - sink.rs7_1 | 0) > 8192)
        throw IllegalArgumentException_init_$Create$_0();
      var tmp0 = sink.qs7_1;
      var tmp2 = sink.qs7_1;
      var tmp5 = sink.rs7_1;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = sink.ss7_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
      sink.ss7_1 = sink.ss7_1 - sink.rs7_1 | 0;
      sink.rs7_1 = 0;
    }
    var tmp0_0 = this.qs7_1;
    var tmp2_0 = sink.qs7_1;
    var tmp4 = sink.ss7_1;
    var tmp6 = this.rs7_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = this.rs7_1 + byteCount | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = tmp0_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
    sink.ss7_1 = sink.ss7_1 + byteCount | 0;
    this.rs7_1 = this.rs7_1 + byteCount | 0;
  };
  protoOf(Segment).ks8 = function (dst, dstStartOffset, dstEndOffset) {
    var len = dstEndOffset - dstStartOffset | 0;
    var tmp0 = this.qs7_1;
    var tmp6 = this.rs7_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.rs7_1 + len | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
    this.rs7_1 = this.rs7_1 + len | 0;
  };
  protoOf(Segment).vs8 = function (src, srcStartOffset, srcEndOffset) {
    var tmp2 = this.qs7_1;
    // Inline function 'kotlin.collections.copyInto' call
    var destinationOffset = this.ss7_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
    this.ss7_1 = this.ss7_1 + (srcEndOffset - srcStartOffset | 0) | 0;
  };
  protoOf(Segment).n1 = function () {
    return this.ss7_1 - this.rs7_1 | 0;
  };
  protoOf(Segment).us8 = function () {
    return this.qs7_1.length - this.ss7_1 | 0;
  };
  protoOf(Segment).ys9 = function (readOnly) {
    return this.qs7_1;
  };
  protoOf(Segment).hs8 = function (index) {
    return this.qs7_1[this.rs7_1 + index | 0];
  };
  protoOf(Segment).zs9 = function (index, value) {
    this.qs7_1[this.ss7_1 + index | 0] = value;
  };
  protoOf(Segment).asa = function (index, b0, b1) {
    var d = this.qs7_1;
    var l = this.ss7_1;
    d[l + index | 0] = b0;
    d[(l + index | 0) + 1 | 0] = b1;
  };
  protoOf(Segment).bsa = function (index, b0, b1, b2) {
    var d = this.qs7_1;
    var l = this.ss7_1;
    d[l + index | 0] = b0;
    d[(l + index | 0) + 1 | 0] = b1;
    d[(l + index | 0) + 2 | 0] = b2;
  };
  protoOf(Segment).csa = function (index, b0, b1, b2, b3) {
    var d = this.qs7_1;
    var l = this.ss7_1;
    d[l + index | 0] = b0;
    d[(l + index | 0) + 1 | 0] = b1;
    d[(l + index | 0) + 2 | 0] = b2;
    d[(l + index | 0) + 3 | 0] = b3;
  };
  function Segment() {
    this.rs7_1 = 0;
    this.ss7_1 = 0;
    this.ts7_1 = null;
    this.us7_1 = false;
    this.vs7_1 = null;
    this.ws7_1 = null;
  }
  function isEmpty(_this__u8e3s4) {
    return _this__u8e3s4.n1() === 0;
  }
  function SegmentCopyTracker() {
  }
  function AlwaysSharedCopyTracker() {
    AlwaysSharedCopyTracker_instance = this;
    SegmentCopyTracker.call(this);
  }
  protoOf(AlwaysSharedCopyTracker).vs9 = function () {
    return true;
  };
  protoOf(AlwaysSharedCopyTracker).xs9 = function () {
    return Unit_instance;
  };
  var AlwaysSharedCopyTracker_instance;
  function AlwaysSharedCopyTracker_getInstance() {
    if (AlwaysSharedCopyTracker_instance == null)
      new AlwaysSharedCopyTracker();
    return AlwaysSharedCopyTracker_instance;
  }
  function indexOf_0(_this__u8e3s4, byte, startOffset, endOffset) {
    // Inline function 'kotlin.require' call
    if (!(0 <= startOffset ? startOffset < _this__u8e3s4.n1() : false)) {
      var message = '' + startOffset;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.n1() : false)) {
      var message_0 = '' + endOffset;
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var p = _this__u8e3s4.rs7_1;
    var data = _this__u8e3s4.ys9(true);
    var inductionVariable = startOffset;
    if (inductionVariable < endOffset)
      do {
        var idx = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (data[p + idx | 0] === byte) {
          return idx;
        }
      }
       while (inductionVariable < endOffset);
    return -1;
  }
  function Sink() {
  }
  function Source() {
  }
  function readByteArray(_this__u8e3s4) {
    return readByteArrayImpl(_this__u8e3s4, -1);
  }
  function readByteArray_0(_this__u8e3s4, byteCount) {
    // Inline function 'kotlinx.io.checkByteCount' call
    var byteCount_0 = fromInt(byteCount);
    // Inline function 'kotlin.require' call
    if (!(compare(byteCount_0, new Long(0, 0)) >= 0)) {
      var message = 'byteCount (' + byteCount_0.toString() + ') < 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return readByteArrayImpl(_this__u8e3s4, byteCount);
  }
  function indexOf_1(_this__u8e3s4, byte, startIndex, endIndex) {
    startIndex = startIndex === VOID ? new Long(0, 0) : startIndex;
    endIndex = endIndex === VOID ? new Long(-1, 2147483647) : endIndex;
    // Inline function 'kotlin.require' call
    if (!(compare(new Long(0, 0), startIndex) <= 0 ? compare(startIndex, endIndex) <= 0 : false)) {
      var tmp;
      if (compare(endIndex, new Long(0, 0)) < 0) {
        tmp = 'startIndex (' + startIndex.toString() + ') and endIndex (' + endIndex.toString() + ') should be non negative';
      } else {
        tmp = 'startIndex (' + startIndex.toString() + ') is not within the range [0..endIndex(' + endIndex.toString() + '))';
      }
      var message = tmp;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (equalsLong(startIndex, endIndex))
      return new Long(-1, -1);
    var offset = startIndex;
    $l$loop: while (true) {
      var tmp_0;
      if (compare(offset, endIndex) < 0) {
        // Inline function 'kotlin.Long.plus' call
        var this_0 = offset;
        var tmp$ret$2 = add(this_0, fromInt(1));
        tmp_0 = _this__u8e3s4.os7(tmp$ret$2);
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        break $l$loop;
      }
      var tmp_1 = _this__u8e3s4.ls7();
      var tmp_2 = offset;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = _this__u8e3s4.ls7().n1();
      var tmp$ret$3 = compare(endIndex, b) <= 0 ? endIndex : b;
      var idx = indexOf(tmp_1, byte, tmp_2, tmp$ret$3);
      if (!equalsLong(idx, new Long(-1, -1))) {
        return idx;
      }
      offset = _this__u8e3s4.ls7().n1();
    }
    return new Long(-1, -1);
  }
  function readByteArrayImpl(_this__u8e3s4, size) {
    var arraySize = size;
    if (size === -1) {
      var fetchSize = new Long(2147483647, 0);
      while (compare(_this__u8e3s4.ls7().n1(), new Long(2147483647, 0)) < 0 && _this__u8e3s4.os7(fetchSize)) {
        // Inline function 'kotlin.Long.times' call
        var this_0 = fetchSize;
        fetchSize = multiply(this_0, fromInt(2));
      }
      // Inline function 'kotlin.check' call
      if (!(compare(_this__u8e3s4.ls7().n1(), new Long(2147483647, 0)) < 0)) {
        var message = "Can't create an array of size " + _this__u8e3s4.ls7().n1().toString();
        throw IllegalStateException_init_$Create$(toString(message));
      }
      arraySize = convertToInt(_this__u8e3s4.ls7().n1());
    } else {
      _this__u8e3s4.ns7(fromInt(size));
    }
    var array = new Int8Array(arraySize);
    readTo(_this__u8e3s4.ls7(), array);
    return array;
  }
  function readTo(_this__u8e3s4, sink, startIndex, endIndex) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? sink.length : endIndex;
    // Inline function 'kotlinx.io.checkBounds' call
    var size = sink.length;
    checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
    var offset = startIndex;
    while (offset < endIndex) {
      var bytesRead = _this__u8e3s4.js8(sink, offset, endIndex);
      if (bytesRead === -1) {
        throw EOFException_init_$Create$_0('Source exhausted before reading ' + (endIndex - startIndex | 0) + ' bytes. ' + ('Only ' + bytesRead + ' bytes were read.'));
      }
      offset = offset + bytesRead | 0;
    }
  }
  function readString(_this__u8e3s4, byteCount) {
    _this__u8e3s4.ns7(byteCount);
    return commonReadUtf8(_this__u8e3s4.ls7(), byteCount);
  }
  function readString_0(_this__u8e3s4) {
    _this__u8e3s4.os7(new Long(-1, 2147483647));
    return commonReadUtf8(_this__u8e3s4.ls7(), _this__u8e3s4.ls7().n1());
  }
  function writeString(_this__u8e3s4, string, startIndex, endIndex) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? string.length : endIndex;
    // Inline function 'kotlinx.io.checkBounds' call
    var size = string.length;
    checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
    // Inline function 'kotlinx.io.writeToInternalBuffer' call
    // Inline function 'kotlinx.io.commonWriteUtf8' call
    var this_0 = _this__u8e3s4.ls7();
    var i = startIndex;
    while (i < endIndex) {
      var p0 = i;
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt(string, p0);
      var c = Char__toInt_impl_vasixd(this_1);
      if (c < 128) {
        $l$block_0: {
          // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
          var tail = this_0.ps8(1);
          var ctx = get_SegmentWriteContextImpl();
          var segmentOffset = -i | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = i + tail.us8() | 0;
          var runLimit = Math.min(endIndex, b);
          var _unary__edvuaz = i;
          i = _unary__edvuaz + 1 | 0;
          ctx.gsa(tail, segmentOffset + _unary__edvuaz | 0, toByte(c));
          $l$loop: while (i < runLimit) {
            var p0_0 = i;
            // Inline function 'kotlin.code' call
            var this_2 = charCodeAt(string, p0_0);
            c = Char__toInt_impl_vasixd(this_2);
            if (c >= 128)
              break $l$loop;
            var _unary__edvuaz_0 = i;
            i = _unary__edvuaz_0 + 1 | 0;
            ctx.gsa(tail, segmentOffset + _unary__edvuaz_0 | 0, toByte(c));
          }
          var bytesWritten = i + segmentOffset | 0;
          if (bytesWritten === 1) {
            tail.ss7_1 = tail.ss7_1 + bytesWritten | 0;
            var tmp = this_0;
            // Inline function 'kotlin.Long.plus' call
            var this_3 = this_0.ks7_1;
            tmp.ks7_1 = add(this_3, fromInt(bytesWritten));
            break $l$block_0;
          }
          // Inline function 'kotlin.check' call
          if (!(0 <= bytesWritten ? bytesWritten <= tail.us8() : false)) {
            var message = 'Invalid number of bytes written: ' + bytesWritten + '. Should be in 0..' + tail.us8();
            throw IllegalStateException_init_$Create$(toString(message));
          }
          if (!(bytesWritten === 0)) {
            tail.ss7_1 = tail.ss7_1 + bytesWritten | 0;
            var tmp_0 = this_0;
            // Inline function 'kotlin.Long.plus' call
            var this_4 = this_0.ks7_1;
            tmp_0.ks7_1 = add(this_4, fromInt(bytesWritten));
            break $l$block_0;
          }
          if (isEmpty(tail)) {
            this_0.is9();
          }
        }
      } else if (c < 2048) {
        $l$block_2: {
          // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
          var tail_0 = this_0.ps8(2);
          get_SegmentWriteContextImpl().fsa(tail_0, 0, toByte(c >> 6 | 192), toByte(c & 63 | 128));
          var bytesWritten_0 = 2;
          if (bytesWritten_0 === 2) {
            tail_0.ss7_1 = tail_0.ss7_1 + bytesWritten_0 | 0;
            var tmp_1 = this_0;
            // Inline function 'kotlin.Long.plus' call
            var this_5 = this_0.ks7_1;
            tmp_1.ks7_1 = add(this_5, fromInt(bytesWritten_0));
            break $l$block_2;
          }
          // Inline function 'kotlin.check' call
          if (!(0 <= bytesWritten_0 ? bytesWritten_0 <= tail_0.us8() : false)) {
            var message_0 = 'Invalid number of bytes written: ' + bytesWritten_0 + '. Should be in 0..' + tail_0.us8();
            throw IllegalStateException_init_$Create$(toString(message_0));
          }
          if (!(bytesWritten_0 === 0)) {
            tail_0.ss7_1 = tail_0.ss7_1 + bytesWritten_0 | 0;
            var tmp_2 = this_0;
            // Inline function 'kotlin.Long.plus' call
            var this_6 = this_0.ks7_1;
            tmp_2.ks7_1 = add(this_6, fromInt(bytesWritten_0));
            break $l$block_2;
          }
          if (isEmpty(tail_0)) {
            this_0.is9();
          }
        }
        i = i + 1 | 0;
      } else if (c < 55296 || c > 57343) {
        $l$block_4: {
          // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
          var tail_1 = this_0.ps8(3);
          get_SegmentWriteContextImpl().esa(tail_1, 0, toByte(c >> 12 | 224), toByte(c >> 6 & 63 | 128), toByte(c & 63 | 128));
          var bytesWritten_1 = 3;
          if (bytesWritten_1 === 3) {
            tail_1.ss7_1 = tail_1.ss7_1 + bytesWritten_1 | 0;
            var tmp_3 = this_0;
            // Inline function 'kotlin.Long.plus' call
            var this_7 = this_0.ks7_1;
            tmp_3.ks7_1 = add(this_7, fromInt(bytesWritten_1));
            break $l$block_4;
          }
          // Inline function 'kotlin.check' call
          if (!(0 <= bytesWritten_1 ? bytesWritten_1 <= tail_1.us8() : false)) {
            var message_1 = 'Invalid number of bytes written: ' + bytesWritten_1 + '. Should be in 0..' + tail_1.us8();
            throw IllegalStateException_init_$Create$(toString(message_1));
          }
          if (!(bytesWritten_1 === 0)) {
            tail_1.ss7_1 = tail_1.ss7_1 + bytesWritten_1 | 0;
            var tmp_4 = this_0;
            // Inline function 'kotlin.Long.plus' call
            var this_8 = this_0.ks7_1;
            tmp_4.ks7_1 = add(this_8, fromInt(bytesWritten_1));
            break $l$block_4;
          }
          if (isEmpty(tail_1)) {
            this_0.is9();
          }
        }
        i = i + 1 | 0;
      } else {
        var tmp_5;
        if ((i + 1 | 0) < endIndex) {
          var p0_1 = i + 1 | 0;
          // Inline function 'kotlin.code' call
          var this_9 = charCodeAt(string, p0_1);
          tmp_5 = Char__toInt_impl_vasixd(this_9);
        } else {
          tmp_5 = 0;
        }
        var low = tmp_5;
        if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
          // Inline function 'kotlin.code' call
          var this_10 = _Char___init__impl__6a9atx(63);
          var tmp$ret$29 = Char__toInt_impl_vasixd(this_10);
          this_0.cs9(toByte(tmp$ret$29));
          i = i + 1 | 0;
        } else {
          var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
          $l$block_6: {
            // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.writeToTail' call
            var tail_2 = this_0.ps8(4);
            get_SegmentWriteContextImpl().dsa(tail_2, 0, toByte(codePoint >> 18 | 240), toByte(codePoint >> 12 & 63 | 128), toByte(codePoint >> 6 & 63 | 128), toByte(codePoint & 63 | 128));
            var bytesWritten_2 = 4;
            if (bytesWritten_2 === 4) {
              tail_2.ss7_1 = tail_2.ss7_1 + bytesWritten_2 | 0;
              var tmp_6 = this_0;
              // Inline function 'kotlin.Long.plus' call
              var this_11 = this_0.ks7_1;
              tmp_6.ks7_1 = add(this_11, fromInt(bytesWritten_2));
              break $l$block_6;
            }
            // Inline function 'kotlin.check' call
            if (!(0 <= bytesWritten_2 ? bytesWritten_2 <= tail_2.us8() : false)) {
              var message_2 = 'Invalid number of bytes written: ' + bytesWritten_2 + '. Should be in 0..' + tail_2.us8();
              throw IllegalStateException_init_$Create$(toString(message_2));
            }
            if (!(bytesWritten_2 === 0)) {
              tail_2.ss7_1 = tail_2.ss7_1 + bytesWritten_2 | 0;
              var tmp_7 = this_0;
              // Inline function 'kotlin.Long.plus' call
              var this_12 = this_0.ks7_1;
              tmp_7.ks7_1 = add(this_12, fromInt(bytesWritten_2));
              break $l$block_6;
            }
            if (isEmpty(tail_2)) {
              this_0.is9();
            }
          }
          i = i + 2 | 0;
        }
      }
    }
    _this__u8e3s4.bs8();
  }
  function commonReadUtf8(_this__u8e3s4, byteCount) {
    if (equalsLong(byteCount, new Long(0, 0)))
      return '';
    // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
    var curr = _this__u8e3s4.is7_1;
    while (!(curr == null)) {
      get_SegmentReadContextImpl();
      if (compare(fromInt(curr.n1()), byteCount) >= 0) {
        var result = '';
        // Inline function 'kotlinx.io.unsafe.withData' call
        var tmp0 = curr.ys9(true);
        var tmp2 = curr.rs7_1;
        var tmp0_0 = curr.ss7_1;
        // Inline function 'kotlin.math.min' call
        var b = tmp2 + convertToInt(byteCount) | 0;
        var tmp$ret$4 = Math.min(tmp0_0, b);
        result = commonToUtf8String(tmp0, tmp2, tmp$ret$4);
        _this__u8e3s4.is8(byteCount);
        return result;
      }
      return commonToUtf8String(readByteArray_0(_this__u8e3s4, convertToInt(byteCount)));
    }
    // Inline function 'kotlin.error' call
    var message = 'Unreacheable';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function commonToUtf8String(_this__u8e3s4, beginIndex, endIndex) {
    beginIndex = beginIndex === VOID ? 0 : beginIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
    if (beginIndex < 0 || endIndex > _this__u8e3s4.length || beginIndex > endIndex) {
      throw IndexOutOfBoundsException_init_$Create$('size=' + _this__u8e3s4.length + ' beginIndex=' + beginIndex + ' endIndex=' + endIndex);
    }
    var chars = charArray(endIndex - beginIndex | 0);
    var length = 0;
    // Inline function 'kotlinx.io.internal.processUtf16Chars' call
    var index = beginIndex;
    while (index < endIndex) {
      var b0 = _this__u8e3s4[index];
      if (b0 >= 0) {
        var c = numberToChar(b0);
        var _unary__edvuaz = length;
        length = _unary__edvuaz + 1 | 0;
        chars[_unary__edvuaz] = c;
        index = index + 1 | 0;
        while (index < endIndex && _this__u8e3s4[index] >= 0) {
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          var c_0 = numberToChar(_this__u8e3s4[_unary__edvuaz_0]);
          var _unary__edvuaz_1 = length;
          length = _unary__edvuaz_1 + 1 | 0;
          chars[_unary__edvuaz_1] = c_0;
        }
      } else {
        // Inline function 'kotlinx.io.shr' call
        if (b0 >> 5 === -2) {
          var tmp = index;
          var tmp2 = index;
          var tmp$ret$4;
          $l$block_0: {
            // Inline function 'kotlinx.io.internal.process2Utf8Bytes' call
            if (endIndex <= (tmp2 + 1 | 0)) {
              var c_1 = numberToChar(65533);
              var _unary__edvuaz_2 = length;
              length = _unary__edvuaz_2 + 1 | 0;
              chars[_unary__edvuaz_2] = c_1;
              tmp$ret$4 = 1;
              break $l$block_0;
            }
            var b0_0 = _this__u8e3s4[tmp2];
            var b1 = _this__u8e3s4[tmp2 + 1 | 0];
            // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
            // Inline function 'kotlinx.io.and' call
            if (!((b1 & 192) === 128)) {
              var c_2 = numberToChar(65533);
              var _unary__edvuaz_3 = length;
              length = _unary__edvuaz_3 + 1 | 0;
              chars[_unary__edvuaz_3] = c_2;
              tmp$ret$4 = 1;
              break $l$block_0;
            }
            var codePoint = 3968 ^ b1 ^ b0_0 << 6;
            if (codePoint < 128) {
              var c_3 = numberToChar(65533);
              var _unary__edvuaz_4 = length;
              length = _unary__edvuaz_4 + 1 | 0;
              chars[_unary__edvuaz_4] = c_3;
            } else {
              var c_4 = numberToChar(codePoint);
              var _unary__edvuaz_5 = length;
              length = _unary__edvuaz_5 + 1 | 0;
              chars[_unary__edvuaz_5] = c_4;
            }
            tmp$ret$4 = 2;
          }
          index = tmp + tmp$ret$4 | 0;
        } else {
          // Inline function 'kotlinx.io.shr' call
          if (b0 >> 4 === -2) {
            var tmp_0 = index;
            var tmp2_0 = index;
            var tmp$ret$16;
            $l$block_4: {
              // Inline function 'kotlinx.io.internal.process3Utf8Bytes' call
              if (endIndex <= (tmp2_0 + 2 | 0)) {
                var c_5 = numberToChar(65533);
                var _unary__edvuaz_6 = length;
                length = _unary__edvuaz_6 + 1 | 0;
                chars[_unary__edvuaz_6] = c_5;
                var tmp_1;
                if (endIndex <= (tmp2_0 + 1 | 0)) {
                  tmp_1 = true;
                } else {
                  // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                  // Inline function 'kotlinx.io.and' call
                  tmp_1 = !((_this__u8e3s4[tmp2_0 + 1 | 0] & 192) === 128);
                }
                if (tmp_1) {
                  tmp$ret$16 = 1;
                  break $l$block_4;
                } else {
                  tmp$ret$16 = 2;
                  break $l$block_4;
                }
              }
              var b0_1 = _this__u8e3s4[tmp2_0];
              var b1_0 = _this__u8e3s4[tmp2_0 + 1 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b1_0 & 192) === 128)) {
                var c_6 = numberToChar(65533);
                var _unary__edvuaz_7 = length;
                length = _unary__edvuaz_7 + 1 | 0;
                chars[_unary__edvuaz_7] = c_6;
                tmp$ret$16 = 1;
                break $l$block_4;
              }
              var b2 = _this__u8e3s4[tmp2_0 + 2 | 0];
              // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
              // Inline function 'kotlinx.io.and' call
              if (!((b2 & 192) === 128)) {
                var c_7 = numberToChar(65533);
                var _unary__edvuaz_8 = length;
                length = _unary__edvuaz_8 + 1 | 0;
                chars[_unary__edvuaz_8] = c_7;
                tmp$ret$16 = 2;
                break $l$block_4;
              }
              var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
              if (codePoint_0 < 2048) {
                var c_8 = numberToChar(65533);
                var _unary__edvuaz_9 = length;
                length = _unary__edvuaz_9 + 1 | 0;
                chars[_unary__edvuaz_9] = c_8;
              } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
                var c_9 = numberToChar(65533);
                var _unary__edvuaz_10 = length;
                length = _unary__edvuaz_10 + 1 | 0;
                chars[_unary__edvuaz_10] = c_9;
              } else {
                var c_10 = numberToChar(codePoint_0);
                var _unary__edvuaz_11 = length;
                length = _unary__edvuaz_11 + 1 | 0;
                chars[_unary__edvuaz_11] = c_10;
              }
              tmp$ret$16 = 3;
            }
            index = tmp_0 + tmp$ret$16 | 0;
          } else {
            // Inline function 'kotlinx.io.shr' call
            if (b0 >> 3 === -2) {
              var tmp_2 = index;
              var tmp2_1 = index;
              var tmp$ret$36;
              $l$block_10: {
                // Inline function 'kotlinx.io.internal.process4Utf8Bytes' call
                if (endIndex <= (tmp2_1 + 3 | 0)) {
                  if (!(65533 === 65533)) {
                    var c_11 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_12 = length;
                    length = _unary__edvuaz_12 + 1 | 0;
                    chars[_unary__edvuaz_12] = c_11;
                    var c_12 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_13 = length;
                    length = _unary__edvuaz_13 + 1 | 0;
                    chars[_unary__edvuaz_13] = c_12;
                  } else {
                    var c_13 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_14 = length;
                    length = _unary__edvuaz_14 + 1 | 0;
                    chars[_unary__edvuaz_14] = c_13;
                  }
                  var tmp_3;
                  if (endIndex <= (tmp2_1 + 1 | 0)) {
                    tmp_3 = true;
                  } else {
                    // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                    // Inline function 'kotlinx.io.and' call
                    tmp_3 = !((_this__u8e3s4[tmp2_1 + 1 | 0] & 192) === 128);
                  }
                  if (tmp_3) {
                    tmp$ret$36 = 1;
                    break $l$block_10;
                  } else {
                    var tmp_4;
                    if (endIndex <= (tmp2_1 + 2 | 0)) {
                      tmp_4 = true;
                    } else {
                      // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                      // Inline function 'kotlinx.io.and' call
                      tmp_4 = !((_this__u8e3s4[tmp2_1 + 2 | 0] & 192) === 128);
                    }
                    if (tmp_4) {
                      tmp$ret$36 = 2;
                      break $l$block_10;
                    } else {
                      tmp$ret$36 = 3;
                      break $l$block_10;
                    }
                  }
                }
                var b0_2 = _this__u8e3s4[tmp2_1];
                var b1_1 = _this__u8e3s4[tmp2_1 + 1 | 0];
                // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                // Inline function 'kotlinx.io.and' call
                if (!((b1_1 & 192) === 128)) {
                  if (!(65533 === 65533)) {
                    var c_14 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_15 = length;
                    length = _unary__edvuaz_15 + 1 | 0;
                    chars[_unary__edvuaz_15] = c_14;
                    var c_15 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_16 = length;
                    length = _unary__edvuaz_16 + 1 | 0;
                    chars[_unary__edvuaz_16] = c_15;
                  } else {
                    var c_16 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_17 = length;
                    length = _unary__edvuaz_17 + 1 | 0;
                    chars[_unary__edvuaz_17] = c_16;
                  }
                  tmp$ret$36 = 1;
                  break $l$block_10;
                }
                var b2_0 = _this__u8e3s4[tmp2_1 + 2 | 0];
                // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                // Inline function 'kotlinx.io.and' call
                if (!((b2_0 & 192) === 128)) {
                  if (!(65533 === 65533)) {
                    var c_17 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_18 = length;
                    length = _unary__edvuaz_18 + 1 | 0;
                    chars[_unary__edvuaz_18] = c_17;
                    var c_18 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_19 = length;
                    length = _unary__edvuaz_19 + 1 | 0;
                    chars[_unary__edvuaz_19] = c_18;
                  } else {
                    var c_19 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_20 = length;
                    length = _unary__edvuaz_20 + 1 | 0;
                    chars[_unary__edvuaz_20] = c_19;
                  }
                  tmp$ret$36 = 2;
                  break $l$block_10;
                }
                var b3 = _this__u8e3s4[tmp2_1 + 3 | 0];
                // Inline function 'kotlinx.io.internal.isUtf8Continuation' call
                // Inline function 'kotlinx.io.and' call
                if (!((b3 & 192) === 128)) {
                  if (!(65533 === 65533)) {
                    var c_20 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_21 = length;
                    length = _unary__edvuaz_21 + 1 | 0;
                    chars[_unary__edvuaz_21] = c_20;
                    var c_21 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_22 = length;
                    length = _unary__edvuaz_22 + 1 | 0;
                    chars[_unary__edvuaz_22] = c_21;
                  } else {
                    var c_22 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_23 = length;
                    length = _unary__edvuaz_23 + 1 | 0;
                    chars[_unary__edvuaz_23] = c_22;
                  }
                  tmp$ret$36 = 3;
                  break $l$block_10;
                }
                var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
                if (codePoint_1 > 1114111) {
                  if (!(65533 === 65533)) {
                    var c_23 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_24 = length;
                    length = _unary__edvuaz_24 + 1 | 0;
                    chars[_unary__edvuaz_24] = c_23;
                    var c_24 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_25 = length;
                    length = _unary__edvuaz_25 + 1 | 0;
                    chars[_unary__edvuaz_25] = c_24;
                  } else {
                    var c_25 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_26 = length;
                    length = _unary__edvuaz_26 + 1 | 0;
                    chars[_unary__edvuaz_26] = c_25;
                  }
                } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                  if (!(65533 === 65533)) {
                    var c_26 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_27 = length;
                    length = _unary__edvuaz_27 + 1 | 0;
                    chars[_unary__edvuaz_27] = c_26;
                    var c_27 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_28 = length;
                    length = _unary__edvuaz_28 + 1 | 0;
                    chars[_unary__edvuaz_28] = c_27;
                  } else {
                    var c_28 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_29 = length;
                    length = _unary__edvuaz_29 + 1 | 0;
                    chars[_unary__edvuaz_29] = c_28;
                  }
                } else if (codePoint_1 < 65536) {
                  if (!(65533 === 65533)) {
                    var c_29 = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_30 = length;
                    length = _unary__edvuaz_30 + 1 | 0;
                    chars[_unary__edvuaz_30] = c_29;
                    var c_30 = numberToChar((65533 & 1023) + 56320 | 0);
                    var _unary__edvuaz_31 = length;
                    length = _unary__edvuaz_31 + 1 | 0;
                    chars[_unary__edvuaz_31] = c_30;
                  } else {
                    var c_31 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_32 = length;
                    length = _unary__edvuaz_32 + 1 | 0;
                    chars[_unary__edvuaz_32] = c_31;
                  }
                } else {
                  if (!(codePoint_1 === 65533)) {
                    var c_32 = numberToChar((codePoint_1 >>> 10 | 0) + 55232 | 0);
                    var _unary__edvuaz_33 = length;
                    length = _unary__edvuaz_33 + 1 | 0;
                    chars[_unary__edvuaz_33] = c_32;
                    var c_33 = numberToChar((codePoint_1 & 1023) + 56320 | 0);
                    var _unary__edvuaz_34 = length;
                    length = _unary__edvuaz_34 + 1 | 0;
                    chars[_unary__edvuaz_34] = c_33;
                  } else {
                    var c_34 = _Char___init__impl__6a9atx(65533);
                    var _unary__edvuaz_35 = length;
                    length = _unary__edvuaz_35 + 1 | 0;
                    chars[_unary__edvuaz_35] = c_34;
                  }
                }
                tmp$ret$36 = 4;
              }
              index = tmp_2 + tmp$ret$36 | 0;
            } else {
              var c_35 = _Char___init__impl__6a9atx(65533);
              var _unary__edvuaz_36 = length;
              length = _unary__edvuaz_36 + 1 | 0;
              chars[_unary__edvuaz_36] = c_35;
              index = index + 1 | 0;
            }
          }
        }
      }
    }
    return concatToString(chars, 0, length);
  }
  function get_SegmentReadContextImpl() {
    _init_properties_UnsafeBufferOperations_kt__xw75gy();
    return SegmentReadContextImpl;
  }
  var SegmentReadContextImpl;
  function get_SegmentWriteContextImpl() {
    _init_properties_UnsafeBufferOperations_kt__xw75gy();
    return SegmentWriteContextImpl;
  }
  var SegmentWriteContextImpl;
  var BufferIterationContextImpl;
  function UnsafeBufferOperations() {
  }
  var UnsafeBufferOperations_instance;
  function UnsafeBufferOperations_getInstance() {
    return UnsafeBufferOperations_instance;
  }
  function SegmentReadContextImpl$1() {
  }
  protoOf(SegmentReadContextImpl$1).gs9 = function (segment, offset) {
    return segment.hs8(offset);
  };
  function SegmentWriteContextImpl$1() {
  }
  protoOf(SegmentWriteContextImpl$1).gsa = function (segment, offset, value) {
    segment.zs9(offset, value);
  };
  protoOf(SegmentWriteContextImpl$1).fsa = function (segment, offset, b0, b1) {
    segment.asa(offset, b0, b1);
  };
  protoOf(SegmentWriteContextImpl$1).esa = function (segment, offset, b0, b1, b2) {
    segment.bsa(offset, b0, b1, b2);
  };
  protoOf(SegmentWriteContextImpl$1).dsa = function (segment, offset, b0, b1, b2, b3) {
    segment.csa(offset, b0, b1, b2, b3);
  };
  function BufferIterationContextImpl$1() {
  }
  protoOf(BufferIterationContextImpl$1).gs9 = function (segment, offset) {
    return get_SegmentReadContextImpl().gs9(segment, offset);
  };
  var properties_initialized_UnsafeBufferOperations_kt_2xfgoc;
  function _init_properties_UnsafeBufferOperations_kt__xw75gy() {
    if (!properties_initialized_UnsafeBufferOperations_kt_2xfgoc) {
      properties_initialized_UnsafeBufferOperations_kt_2xfgoc = true;
      SegmentReadContextImpl = new SegmentReadContextImpl$1();
      SegmentWriteContextImpl = new SegmentWriteContextImpl$1();
      BufferIterationContextImpl = new BufferIterationContextImpl$1();
    }
  }
  function IOException_init_$Init$($this) {
    Exception_init_$Init$($this);
    IOException.call($this);
    return $this;
  }
  function IOException_init_$Create$() {
    var tmp = IOException_init_$Init$(objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$);
    return tmp;
  }
  function IOException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    IOException.call($this);
    return $this;
  }
  function IOException_init_$Create$_0(message) {
    var tmp = IOException_init_$Init$_0(message, objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$_0);
    return tmp;
  }
  function IOException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    IOException.call($this);
    return $this;
  }
  function IOException_init_$Create$_1(message, cause) {
    var tmp = IOException_init_$Init$_1(message, cause, objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$_1);
    return tmp;
  }
  function IOException() {
    captureStack(this, IOException);
  }
  function EOFException_init_$Init$($this) {
    IOException_init_$Init$($this);
    EOFException.call($this);
    return $this;
  }
  function EOFException_init_$Create$() {
    var tmp = EOFException_init_$Init$(objectCreate(protoOf(EOFException)));
    captureStack(tmp, EOFException_init_$Create$);
    return tmp;
  }
  function EOFException_init_$Init$_0(message, $this) {
    IOException_init_$Init$_0(message, $this);
    EOFException.call($this);
    return $this;
  }
  function EOFException_init_$Create$_0(message) {
    var tmp = EOFException_init_$Init$_0(message, objectCreate(protoOf(EOFException)));
    captureStack(tmp, EOFException_init_$Create$_0);
    return tmp;
  }
  function EOFException() {
    captureStack(this, EOFException);
  }
  function SegmentPool() {
    this.qs8_1 = 0;
    this.rs8_1 = 0;
  }
  protoOf(SegmentPool).ss8 = function () {
    return Companion_instance.us9();
  };
  protoOf(SegmentPool).hs9 = function (segment) {
  };
  protoOf(SegmentPool).ws9 = function () {
    return AlwaysSharedCopyTracker_getInstance();
  };
  var SegmentPool_instance;
  function SegmentPool_getInstance() {
    return SegmentPool_instance;
  }
  //region block: post-declaration
  protoOf(Buffer).ws8 = write$default;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  UnsafeBufferOperations_instance = new UnsafeBufferOperations();
  SegmentPool_instance = new SegmentPool();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = EOFException_init_$Create$_0;
  _.$_$.b = IOException_init_$Init$_0;
  _.$_$.c = IOException_init_$Create$_0;
  _.$_$.d = IOException_init_$Init$_1;
  _.$_$.e = IOException_init_$Create$_1;
  _.$_$.f = Buffer;
  _.$_$.g = IOException;
  _.$_$.h = Source;
  _.$_$.i = indexOf_1;
  _.$_$.j = readByteArray_0;
  _.$_$.k = readByteArray;
  _.$_$.l = readByteString;
  _.$_$.m = readString_0;
  _.$_$.n = readString;
  _.$_$.o = writeString;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlinx-io-kotlinx-io-core.js.map
